// BBNX API response || all responses
export default response => response.data.response || response.data;
